import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from "./store/index.js";
import "view-design/dist/styles/iview.css";
import 'normalize.css';
import './common/css/index.less';
import view from "./config/iview.js";
import i18n from "./i18n/index.js";
import VueLazyload from 'vue-lazyload';
import AOS from "aos";
import config from '@/config/config.js';
import VueClipboard from 'vue-clipboard2';
import myBrand from './components/layout/bread.vue';
Vue.use(VueClipboard);
import "aos/dist/aos.css";
AOS.init({
    duration: 1000,
    once: true
});
view(Vue);
Vue.component(myBrand.name, myBrand);
Vue.prototype.$config = config;
Vue.config.productionTip = false;
Vue.use(VueLazyload, {
    preLoad: 1.3,
});

new Vue({
    i18n,
    router,
    store,
    render: h => h(App)
}).$mount('#app');